/**
 * @generated SignedSource<<9aca81dda19b7baa686171f884d03e88>>
 * @relayHash c7f2a3c644e7ad31de1025becb232572
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f6cb9ed4f9983f50c5a2808ec95b8f49c6f9b38fec61405ad48cf2f2e5222598

import type { ConcreteRequest } from 'relay-runtime';
export type ServicesAndSkillsSetupActionPreloadedQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type ServicesAndSkillsSetupActionPreloadedQuery$data = {
  readonly agentWorkspace_routingConfig: {
    readonly enabled: boolean;
  } | null;
};
export type ServicesAndSkillsSetupActionPreloadedQuery = {
  response: ServicesAndSkillsSetupActionPreloadedQuery$data;
  variables: ServicesAndSkillsSetupActionPreloadedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
      }
    ],
    "concreteType": "AgentWorkspaceSmartRoutingConfig",
    "kind": "LinkedField",
    "name": "agentWorkspace_routingConfig",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "enabled"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ServicesAndSkillsSetupActionPreloadedQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServicesAndSkillsSetupActionPreloadedQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "f6cb9ed4f9983f50c5a2808ec95b8f49c6f9b38fec61405ad48cf2f2e5222598",
    "metadata": {},
    "name": "ServicesAndSkillsSetupActionPreloadedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b8b23a7de27d6f4bd1d60bedd14eefaa";

export default node;
